import React, { useLayoutEffect } from 'react';
import HubBackground from '../effects/HubBackground';
import { useIsMobile } from '../../../hooks/useIsMobile.js';

/**
 * 認証系画面の共通シェル（背景 + カード入場アニメ）
 *
 * Auth は画面中央固定のため IO だと下方リンクが visible にならないことがある。
 * paint 前に .visible を付与し、Login と同系統の riseFromDarkness を確実に発火させる。
 *
 * @param {object} props
 * @param {React.ReactNode} props.children カード内コンテンツ
 * @param {React.ReactNode} [props.outside] カード外（例: 新規登録リンク）。同じく hub-panel-animated 可
 * @param {string} [props.containerClassName]
 * @param {string} [props.cardClassName]
 * @param {object} [props.containerStyle]
 * @param {unknown[]} [props.revealDeps] 変化時に入場を再発火（Signup の step など）
 * @param {React.ReactNode} [props.beforeContainer] コンテナ前（例: β告知モーダル）
 */
const HubAuthShell = ({
  children,
  outside = null,
  containerClassName = '',
  cardClassName = '',
  containerStyle,
  revealDeps = [],
  beforeContainer = null,
}) => {
  const isMobile = useIsMobile();

  useLayoutEffect(() => {
    document.querySelectorAll('.hub-auth-container .hub-panel-animated').forEach((el) => {
      el.classList.remove('visible');
      // 再入場のため reflow を挟む
      void el.offsetWidth;
      el.classList.add('visible');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- revealDeps のみ再実行
  }, revealDeps);

  return (
    <div className="hub-auth-page">
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      >
        <HubBackground isMobile={isMobile} />
      </div>

      {beforeContainer}

      <div
        className={`hub-auth-container${containerClassName ? ` ${containerClassName}` : ''}`}
        style={{ position: 'relative', zIndex: 1, ...containerStyle }}
      >
        <div className={`hub-auth-card hub-panel-animated${cardClassName ? ` ${cardClassName}` : ''}`}>
          {children}
        </div>
        {outside}
      </div>
    </div>
  );
};

export default HubAuthShell;
